import { data } from "autoprefixer";
import Banner1 from "../assets/images/promotions/banners/banner-1-unicon.jpg";
import Banner2 from "../assets/images/promotions/banners/banner-2-unicon.jpg";
import Banner3 from "../assets/images/promotions/banners/banner-3-unicon.jpg";
import Banner4 from "../assets/images/promotions/banners/banner-4-unicon.jpg";
import Banner5 from "../assets/images/promotions/banners/banner-5-unicon.jpg";
import Banner6 from "../assets/images/promotions/banners/banner-6-unicon.jpg";
import Banner7 from "../assets/images/promotions/banners/banner-7-unicon.jpg";
import Banner8 from "../assets/images/promotions/banners/banner-8-unicon.jpg";

export const quickButtonData = [
  {
    name: "QuickButtons-0",
    row_1: {
      name: "Evolution",
      backgroundImage:
        "url(https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/Evolution-1705911275808?q=65&amp;w=600&amp;px=auto&amp;auto=format)",
      img:
        "https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/Evolution-1705911275817?q=65&amp;w=600&amp;px=auto&amp;auto=format",
      link: "casino-lobby/provider/Evolution Gaming/EVO",
    },
    row_2: {
      name: "Sportsbook",
      backgroundImage:
        "url(https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/Sportsbook-1705911352020?q=65&amp;w=600&amp;px=auto&amp;auto=format)",
      img:
        "https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/Sportsbook-1705911352029?q=65&w=600&px=auto&auto=format",
    },
  },
  {
    name: "QuickButtons-1",
    row_1: {
      name: "Card Games",
      backgroundImage:
        "url(https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/CardGames-1705911853715?q=65&amp;w=600&amp;px=auto&amp;auto=format)",
      img:
        "https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/CardGames-1705911853726?q=65&amp;w=600&amp;px=auto&amp;auto=format",
      link: "casino-lobby/provider/Ezugi/EZU",
    },
    row_2: {
      name: "Aura",
      backgroundImage:
        "url(https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/Aura-1705912199645?q=65&amp;w=600&amp;px=auto&amp;auto=format)",
      img:
        "https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/Aura-1705912199647?q=65&amp;w=600&amp;px=auto&amp;auto=format",
      link: "livegames/aura/FAWK",
    },
  },
  {
    name: "QuickButtons-2",
    row_1: {
      name: "Live Casinos",
      backgroundImage:
        "url(https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/LiveCasinos-1705911704269?q=65&amp;w=600&amp;px=auto&amp;auto=format)",
      img:
        "https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/LiveCasinos-1705911704279?q=65&amp;w=600&amp;px=auto&amp;auto=format",
      link: "casino-lobby/casino",
    },
    row_2: {
      name: "e-Cricket",
      backgroundImage:
        "url(https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/e-Cricket-1705911799120?q=65&amp;w=600&amp;px=auto&amp;auto=format)",
      img:
        "https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/e-Cricket-1705911799122?q=65&amp;w=600&amp;px=auto&amp;auto=format",
      link: "casino-live/EZU-cricketwar/EZU",
    },
  },
  {
    name: "QuickButtons-4",
    row_1: {
      name: "Multiplayer Games",
      backgroundImage:
        "url(https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/MultiplayerGames-1705912077487?q=65&amp;w=600&amp;px=auto&amp;auto=format)",
      img:
        "https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/MultiplayerGames-1705912077489?q=65&amp;w=600&amp;px=auto&amp;auto=format",
      link: "casino-lobby/slot-games/Mines",
    },
    row_2: {
      name: "Slot Games",
      backgroundImage:
        "url(https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/SlotGames-1705912015298?q=65&amp;w=600&amp;px=auto&amp;auto=format)",
      img:
        "https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/SlotGames-1705912015300?q=65&amp;w=600&amp;px=auto&amp;auto=format",
      link: "casino-lobby/slot-games",
    },
  },
  {
    name: "QuickButtons-8",
    row_1: {
      name: "Fishing games",
      backgroundImage:
        "url(https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/Fishinggames-1705912252625?q=65&amp;w=600&amp;px=auto&amp;auto=format&quot;)",
      img:
        "https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/Fishinggames-1705912252627?q=65&amp;w=600&amp;px=auto&amp;auto=format",
      link: "casino-lobby/slot-games/4reel",
    },
    row_2: {
      name: "Color Game",
      backgroundImage:
        "url(https://promotions-material.s3.ap-south-1.amazonaws.com/quickButtons/SlotGames-1705912015298?q=65&w=600&px=auto&auto=format)",
      img:
        "https://promomaterial.imgix.net/quickButtons/ColorGame-1718191763431?q=65&w=600&px=auto&auto=format",
      link: "casino-lobby/slot-games/6reel",
    },
  },
];

export const promotionBanner = [
  {
    _id: "banner_1",
    name: "",
    description: "",
    image: Banner1,
    deleted: false,
    visible: true,
  },
  {
    _id: "banner_2",
    name: "",
    description: "",
    image: Banner2,
    deleted: false,
    visible: true,
  },
  {
    _id: "banner_3",
    name: "",
    description: "",
    image: Banner3,
    deleted: false,
    visible: true,
  },
  {
    _id: "banner_4",
    name: "",
    description: "",
    image: Banner4,
    deleted: false,
    visible: true,
  },
  {
    _id: "banner_5",
    name: "",
    description: "",
    image: Banner5,
    deleted: false,
    visible: true,
  },
  {
    _id: "banner_6",
    name: "",
    description: "",
    image: Banner6,
    deleted: false,
    visible: true,
  },
  {
    _id: "banner_7",
    name: "",
    description: "",
    image: Banner7,
    deleted: false,
    visible: true,
  },
  {
    _id: "banner_8",
    name: "",
    description: "",
    image: Banner8,
    deleted: false,
    visible: true,
  },
];

export const trendingGameDataTabs = [
  {
    name: "Originals",
    index: 0,
  },
  {
    name: "Crash Games",
    index: 1,
  },
  {
    name: "Live Roulette",
    index: 2,
  },
  {
    name: "Money Wheel",
    index: 3,
  },
];
export const trendingGamesData = [
  {
    name: "Originals",
    data: [
      // {
      //   img:
      //     "https://client.qtlauncher.com/images/?id=TRB-dicethrice_en_US&type=logo-square&version=1727165673502",
      //   alt: "Dice-Game",
      //   name: "Dice Thrice",
      //   title:
      //     "https://client.qtlauncher.com/images/?id=TRB-dicethrice_en_US&type=logo-square&version=1727165673502",
      //   gameId: "TRB-dicethrice_en_US",
      //   tableId: "TRB",
      // },
      // {
      //   img:
      //     "https://client.qtlauncher.com/images/?id=HAK-colors_en_US&type=logo-square&version=1696914439395",
      //   alt: "Colors-Game",
      //   name: "Colors",
      //   title:
      //     "https://client.qtlauncher.com/images/?id=HAK-colors_en_US&type=logo-square&version=1696914439395",
      //   gameId: " HAK-colors_en_US",
      //   tableId: "TRB",
      // },
      // {
      //   img:
      //     "https://client.qtlauncher.com/images/?id=TRB-dicetwice_en_US&type=logo-square&version=1689799065045",
      //   alt: "DICE",
      //   name: "DICE TWICE",
      //   title:
      //     "https://client.qtlauncher.com/images/?id=TRB-dicetwice_en_US&type=logo-square&version=1689799065045",
      //   gameId: "TRB-dicetwice_en_US",
      //   tableId: "TRB",
      // },
      {
        img:
          "https://auraimgs.imgix.net/MINES.png?auto=format&amp;fit=max&amp;w=600&amp;q=65&amp;px=auto",
        alt: "casino-event-image",
        name: "Mines",
        title:
          "https://auraimgs.imgix.net/MINES.png?auto=format&amp;fit=max&amp;w=600&amp;q=65",
        gameId: "HAK-mines",
        tableId: "HAK",
        redirect: "livegames/Mines/FAWK/70011",
      },
      {
        img:
          "https://auraimgs.imgix.net/cricket.webp?auto=format&amp;fit=max&amp;w=600&amp;q=65&amp;px=auto",
        alt: "casino-event-image",
        name: "Virtual Cricket",
        title:
          "https://auraimgs.imgix.net/cricket.webp?auto=format&amp;fit=max&amp;w=600&amp;q=65",
        gameId: "WOO-cricketlegends",
        tableId: "WOO",
      },
      {
        img:
          "https://promotions-material.s3.ap-south-1.amazonaws.com/trendingGames/Aviator-1726845520975?q=65&amp;w=600&amp;px=auto&amp;auto=format",
        alt: "casino-event-image",
        name: "Aviator",
        title:
          "https://promotions-material.s3.ap-south-1.amazonaws.com/trendingGames/Aviator-1726845520975",
        gameId: "SPB-aviator",
        tableId: "SPB",
      },
      {
        img:
          "https://auraimgs.imgix.net/crash%20banner-01.webp?auto=format&amp;fit=max&amp;w=600&amp;q=65&amp;px=auto",
        alt: "casino-event-image",
        name: "Crash",
        title:
          "https://auraimgs.imgix.net/crash%20banner-01.webp?auto=format&amp;fit=max&amp;w=600&amp;q=65",
        gameId: "TRB-crashx",
        tableId: "TRB",
      },
      {
        img:
          "https://auraimgs.imgix.net/Untitled-2-05.png?auto=format&amp;fit=max&amp;w=600&amp;q=65&amp;px=auto",
        alt: "casino-event-image",
        name: "Coin Toss",
        title:
          "https://auraimgs.imgix.net/Untitled-2-05.png?auto=format&amp;fit=max&amp;w=600&amp;q=65",
        gameId: "HAK-coins",
        tableId: "HAK",
      },
      {
        img:
          "https://auraimgs.imgix.net/Untitled-2-03.png?auto=format&amp;fit=max&amp;w=600&amp;q=65&amp;px=auto",
        alt: "casino-event-image",
        name: "Slot Game",
        title:
          "https://auraimgs.imgix.net/Untitled-2-03.png?auto=format&amp;fit=max&amp;w=600&amp;q=65",
        gameId: "GA-10luckysevems",
        tableId: "GA",
      },
      {
        img:
          "https://auraimgs.imgix.net/1-04.webp?auto=format&amp;fit=max&amp;w=600&amp;q=65&amp;px=auto",
        alt: "casino-event-image",
        name: "Classis Dice",
        title:
          "https://auraimgs.imgix.net/1-04.webp?auto=format&amp;fit=max&amp;w=600&amp;q=65",
        gameId: "HAK-dice",
        tableId: "HAK",
      },
      // {
      //   img:
      //     "https://auraimgs.imgix.net/5%20game%20posters-02.webp?auto=format&amp;fit=max&amp;w=600&amp;q=65&amp;px=auto",
      //   alt: "casino-event-image",
      //   name: "Limbo",
      //   title:
      //     "https://auraimgs.imgix.net/5%20game%20posters-02.webp?auto=format&amp;fit=max&amp;w=600&amp;q=65",
      //   gameId: "GLX-limbocrash",
      //   tableId: "GLX",
      // },
      {
        img:
          "https://auraimgs.imgix.net/Untitled-2-04.png?auto=format&amp;fit=max&amp;w=600&amp;q=65&amp;px=auto",
        alt: "casino-event-image",
        name: "Fortune Wheel",
        title:
          "https://auraimgs.imgix.net/Untitled-2-04.png?auto=format&amp;fit=max&amp;w=600&amp;q=65",
        gameId: "EVP-magicwheel",
        tableId: "EVP",
      },
    ],
  },
  {
    name: "Crash Games",
    data: [
      {
        img:
          "https://luckmedia.link/spb_aviator/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "Aviator",
        name: "Aviator",
        title: "Aviator",
        gameId: "SPB-aviator",
        tableId: "SPB",
      },
      {
        img:
          "https://luckmedia.link/sms_jetx/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "JetX",
        name: "JetX",
        title: "JetX",
        gameId: "SMS-jetx",
        tableId: "SMS",
      },
      {
        img:
          "https://luckmedia.link/sms_baloon/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "Balloon",
        name: "Balloon",
        title: "Balloon",
        gameId: "SMS-baloon",
        tableId: "SMS",
      },
      {
        img:
          "https://luckmedia.link/sms_cricketx/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "CricketX",
        name: "CricketX",
        title: "CricketX",
        gameId: "SMS-cricketx",
        tableId: "SMS",
      },
      {
        img:
          "https://client.qtlauncher.com/images/?id=OT-cashgalaxy_en_US&type=logo-square&version=1662544075198",
        alt: "Cash Galaxy",
        name: "Cash Galaxy",
        title: "Cash Galaxy",
        gameId: "OT-cashgalaxy",
        tableId: "SMS",
      },
      {
        img:
          "https://luckmedia.link/gmz_pilot/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "Pilot",
        name: "Pilot",
        title: "Pilot",
        gameId: "GZX-pilot",
        tableId: "GZX",
      },
      {
        img:
          "https://luckmedia.link/gmz_pilot_cup/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "Pilot Cup",
        name: "Pilot Cup",
        title: "Pilot Cup",
        gameId: "GZX-pilotcup",
        tableId: "GZX",
      },
      {
        img:
          "https://luckmedia.link/sms_footballx/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "FootballX",
        name: "FootballX",
        title: "FootballX",
        gameId: "SMS-footballx",
        tableId: "SMS",
      },
      {
        img:
          "https://luckmedia.link/gmz_pilot_coin/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "Pilot Coin",
        name: "Pilot Coin",
        title: "Pilot Coin",
        gameId: "GZX-pilotcoin",
        tableId: "GZX",
      },
      {
        img:
          "https://client.qtlauncher.com/images/?id=GMC-jetlucky2_en_US&type=logo-square&version=1694975428848",
        alt: "Jet Lucky 2",
        name: "Jet Lucky 2",
        title: "Jet Lucky 2",
        gameId: "GMC-jetlucky2",
        tableId: "GMC",
      },
      {
        img:
          "https://luckmedia.link/plt_cash_it/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "Cash IT",
        name: "Cash IT",
        title: "Cash IT",
        gameId: "TRB-crashx",
        tableId: "TRB",
      },
      {
        img:
          "https://client.qtlauncher.com/images/?id=RTG-galaxyblast_en_US&type=logo-square&version=1726480865499",
        alt: "Galaxy Blast",
        name: "Galaxy Blast",
        title: "Galaxy Blast",
        gameId: "RTG-galaxyblast",
        tableId: "RTG",
      },
      {
        img:
          "https://client.qtlauncher.com/images/?id=GMC-hohohodl_en_US&type=logo-square&version=1694975184921",
        alt: "Ho Ho HODL",
        name: "Ho Ho HODL",
        title: "Ho Ho HODL",
        gameId: "GMC-hohohodl",
        tableId: "GMC",
      },
      {
        img:
          "https://client.qtlauncher.com/images/?id=GMC-tomarsandbeyond_en_US&type=logo-square&version=1694979436504",
        alt: "To Mars and Beyond",
        name: "To Mars and Beyond",
        title: "To Mars and Beyond",
        gameId: "GMC-tomarsandbeyond",
        tableId: "GMC",
      },
      {
        img:
          "https://client.qtlauncher.com/images/?id=HAK-speedcrash_en_US&type=logo-square&version=1724237441978",
        alt: "Speed Crash",
        name: "Speed Crash",
        title: "Speed Crash",
        gameId: "HAK-speedcrash",
        tableId: "HAK",
      },
      {
        img:
          "https://client.qtlauncher.com/images/?id=BTV-skyward_en_US&type=logo-square&version=1700063782615",
        alt: "Skyward",
        name: "Skyward",
        title: "Skyward",
        gameId: "BTV-skyward",
        tableId: "BTV",
      },
      {
        img:
          "https://client.qtlauncher.com/images/?id=NGE-mriya_en_US&type=logo-square&version=1660632626865",
        alt: "Mriya",
        name: "Mriya",
        title: "Mriya",
        gameId: "NGE-mriya",
        tableId: "NGE",
      },
    ],
  },
  {
    name: "Live Roulette",
    data: [
      {
        gameId: "EZU-32cards",
        name: "32 Cards",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/OTHER",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-32cards_en_US&type=logo-square&version=1678476881377",
      },
      {
        gameId: "EZU-andarbahar",
        name: "Andar Bahar",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/ANDAR_BAHAR",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-andarbahar_en_US&type=logo-square&version=1678476979546",
      },
      {
        gameId: "EZU-automaticroulette",
        name: "Auto Roulette",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/ROULETTE",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-automaticroulette_en_US&type=logo-square&version=1716210438504",
      },
      {
        gameId: "EZU-autoroulette1",
        name: "Auto Roulette 1",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/ROULETTE",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-autoroulette1_en_US&type=logo-square&version=1716214180331",
      },
      {
        gameId: "EZU-baccarat",
        name: "Baccarat",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/BACCARAT",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-baccarat_en_US&type=logo-square&version=1716211287452",
      },
      {
        gameId: "EZU-baccarata",
        name: "Baccarat A",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/BACCARAT",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-baccarata_en_US&type=logo-square&version=1717130391537",
      },
      {
        gameId: "EZU-baccaratb",
        name: "Baccarat B",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/BACCARAT",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-baccaratb_en_US&type=logo-square&version=1717130468376",
      },
      {
        gameId: "EZU-baccaratc",
        name: "Baccarat C",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/BACCARAT",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-baccaratc_en_US&type=logo-square&version=1717019221447",
      },
      {
        gameId: "EZU-baccaratd",
        name: "Baccarat D",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/BACCARAT",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-baccaratd_en_US&type=logo-square&version=1717019142707",
      },
      {
        gameId: "EZU-baccarate",
        name: "Baccarat E",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/BACCARAT",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-baccarate_en_US&type=logo-square&version=1716807942182",
      },
      {
        gameId: "EZU-betonteenpatti",
        name: "Bet on Teen Patti",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/TEEN_PATTI",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-betonteenpatti_en_US&type=logo-square&version=1678477362730",
      },
      {
        gameId: "EZU-blackjack",
        name: "Blackjack",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/BLACKJACK",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-blackjack_en_US&type=logo-square&version=1716210635423",
      },
      {
        gameId: "EZU-blackjacksalonprive",
        name: "Blackjack Salon Privé",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/BLACKJACK",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-blackjacksalonprive_en_US&type=logo-square&version=1678479702991",
      },
      {
        gameId: "EZU-blackjackdasorte",
        name: "Blackjack da Sorte",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/BLACKJACK",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-blackjackdasorte_en_US&type=logo-square&version=1686896424139",
      },
      {
        gameId: "EZU-casinoholdem",
        name: "Casino Hold'em",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/POKER",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-casinoholdem_en_US&type=logo-square&version=1678479919247",
      },
      {
        gameId: "EZU-casinomarinaandarbahar",
        name: "Casino Marina Andar Bahar",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/ANDAR_BAHAR",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-casinomarinaandarbahar_en_US&type=logo-square&version=1685691014988",
      },
      {
        gameId: "EZU-casinomarinabaccarata",
        name: "Casino Marina Baccarat A",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/BACCARAT",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-casinomarinabaccarata_en_US&type=logo-square&version=1715934978159",
      },
      {
        gameId: "EZU-casinomarinabaccaratb",
        name: "Casino Marina Baccarat B",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/BACCARAT",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-casinomarinabaccaratb_en_US&type=logo-square&version=1716808493958",
      },
      {
        gameId: "EZU-casinomarinabaccaratc",
        name: "Casino Marina Baccarat C",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/BACCARAT",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-casinomarinabaccaratc_en_US&type=logo-square&version=1717018982455",
      },
      {
        gameId: "EZU-casinomarinabaccaratd",
        name: "Casino Marina Baccarat D",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/BACCARAT",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-casinomarinabaccaratd_en_US&type=logo-square&version=1716808081093",
      },
      {
        gameId: "EZU-casinomarinaroulette1",
        name: "Casino Marina Roulette 1",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/ROULETTE",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-casinomarinaroulette1_en_US&type=logo-square&version=1715595995744",
      },
      {
        gameId: "EZU-casinomarinaroulette2",
        name: "Casino Marina Roulette 2",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/ROULETTE",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-casinomarinaroulette2_en_US&type=logo-square&version=1715684065675",
      },
      {
        gameId: "EZU-cricketautoroulette",
        name: "Cricket Auto Roulette",
        tableId: "EZU",
        category: "CASINO/LIVECASINO/ROULETTE",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EZU-cricketautoroulette_en_US&type=logo-square&version=1715593194602",
      },
    ],
  },
  {
    name: "",
    data: [
      {
        gameId: "EVO-dreamcatcher",
        name: "Dream Catcher",
        tableId: "EVO",
        category: "CASINO/GAME_SHOW",
        demoSupport: false,
        img:
          "https://client.qtlauncher.com/images/?id=EVO-dreamcatcher_en_US&type=logo-square&version=1678379368909",
      },
      {
        gameId: "BTV-candycoins",
        name: "Candy Coins",
        tableId: "BTV",
        category: "CASINO/SLOT/6REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=BTV-candycoins_en_US&type=logo-square&version=1734441224930",
      },
      {
        gameId: "EVP-headsandtails",
        name: "Heads & Tails",
        tableId: "EVP",
        category: "CASINO/INSTANTWIN/COIN_FLIPPING",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=EVP-headsandtails_en_US&type=logo-square&version=1717749702588",
      },
      {
        gameId: "BTL-solarsands",
        name: "Solar Sands",
        tableId: "BTL",
        category: "CASINO/SLOT/5REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=BTL-solarsands_en_US&type=logo-square&version=1737966368640",
      },
      {
        gameId: "MNP-piratesgold",
        name: "Pirate’s Gold",
        tableId: "MNP",
        category: "CASINO/SLOT/5REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=MNP-piratesgold_en_US&type=logo-square&version=1665752205503",
      },
    ],
  },
];

export const gameShowDataTabs = [
  {
    name: "Game Show",
    index: 0,
  },
  {
    name: "Lottery",
    index: 1,
  },
  {
    name: "Scratch Card",
    index: 2,
  },
];

export const gameShowData = [
  {
    name: "Game Show",
    data: [
      {
        gameId: "IDS-1millionfortunesmegaways",
        name: "1 Million Fortunes Megaways",
        tableId: "IDS",
        category: "CASINO/SLOT/7REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-1millionfortunesmegaways_en_US&type=logo-square&version=1662574283854",
      },
      {
        gameId: "IDS-onemillionmegawaysbc",
        name: "1 Million Megaways BC",
        tableId: "IDS",
        category: "CASINO/SLOT/6REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-onemillionmegawaysbc_en_US&type=logo-square&version=1683023980854",
      },
      {
        gameId: "IDS-3crazytikis",
        name: "3 Crazy Tikis",
        tableId: "IDS",
        category: "CASINO/SLOT/5REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-3crazytikis_en_US&type=logo-square&version=1726489271108",
      },
      {
        gameId: "IDS-3hotchillipeppers",
        name: "3 Hot Chilli Peppers",
        tableId: "IDS",
        category: "CASINO/SLOT/5REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-3hotchillipeppers_en_US&type=logo-square&version=1743583339537",
      },
      {
        gameId: "IDS-3leprechauncharms",
        name: "3 Leprechaun Charms",
        tableId: "IDS",
        category: "CASINO/SLOT/5REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-3leprechauncharms_en_US&type=logo-square&version=1741161318996",
      },
      {
        gameId: "IDS-3pluckyhens",
        name: "3 Plucky Hens",
        tableId: "IDS",
        category: "CASINO/SLOT/5REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-3pluckyhens_en_US&type=logo-square&version=1740554190654",
      },
      {
        gameId: "IDS-3porkybankshnw",
        name: "3 Porky Banks Hold & Win",
        tableId: "IDS",
        category: "CASINO/SLOT/5REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-3porkybankshnw_en_US&type=logo-square&version=1722338408095",
      },
      {
        gameId: "IDS-3porkybankschristmasedition",
        name: "3 Porky Banks: Christmas Edition",
        tableId: "IDS",
        category: "CASINO/SLOT/5REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-3porkybankschristmasedition_en_US&type=logo-square&version=1733319497662",
      },
      {
        gameId: "IDS-3dbaccarat",
        name: "3D Baccarat",
        tableId: "IDS",
        category: "CASINO/TABLEGAME/BACCARAT",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-3dbaccarat_en_US&type=logo-square&version=1678732199305",
      },
      {
        gameId: "IDS-3droulette",
        name: "3D Roulette",
        tableId: "IDS",
        category: "CASINO/TABLEGAME/ROULETTE",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-3droulette_en_US&type=logo-square&version=1678732444607",
      },
      {
        gameId: "IDS-8treasuresluckofthedragon",
        name: "8 Treasures: Luck of the dragon",
        tableId: "IDS",
        category: "CASINO/SLOT/5REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-8treasuresluckofthedragon_en_US&type=logo-square&version=1706614628068",
      },
      {
        gameId: "IDS-apexstrikeluckycache",
        name: "Apex Strike Lucky Cache",
        tableId: "IDS",
        category: "CASINO/SLOT/5REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-apexstrikeluckycache_en_US&type=logo-square&version=1732627963112",
      },
      {
        gameId: "IDS-apexstrikemegaways",
        name: "Apex Strike Megaways",
        tableId: "IDS",
        category: "CASINO/SLOT/6REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-apexstrikemegaways_en_US&type=logo-square&version=1706100249054",
      },
      {
        gameId: "IDS-arribaheatsalsawilds",
        name: "Arriba Heat: Salsa Wilds",
        tableId: "IDS",
        category: "CASINO/SLOT/5REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-arribaheatsalsawilds_en_US&type=logo-square&version=1713865813072",
      },
      {
        gameId: "IDS-astronewtsmegaways",
        name: "Astro Newts Megaways",
        tableId: "IDS",
        category: "CASINO/SLOT/6REEL",
        demoSupport: true,
        img:
          "https://client.qtlauncher.com/images/?id=IDS-astronewtsmegaways_en_US&type=logo-square&version=1678732495320",
      },
    ],
  },
  {
    name: "Lottery",
    data: [
      {
        img:
          "https://luckmedia.link/evo_first_person_mega_ball/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "First Person Mega Ball",
        name: "First Person Mega Ball",
        title: "First Person Mega Ball",
        gameId: "EVO-rngmegaball00001",
        tableId: "EVO",
      },
      {
        img:
          "https://luckmedia.link/spb_keno/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "Keno",
        name: "Keno",
        title: "Keno",
        gameId: "SPB-keno",
        tableId: "SPB",
      },
      {
        img:
          "https://luckmedia.link/png_keno/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "Keno",
        name: "Keno",
        title: "Keno",
        gameId: "PNG-keno",
        tableId: "PNG",
      },
      {
        img:
          "https://client.qtlauncher.com/images/?id=GLX-bingostar_en_US&type=logo-square&version=1703639778113",
        alt: "Bingo Star",
        name: "Bingo Star",
        title: "Bingo Star",
        gameId: "GLX-bingostar",
        tableId: "GLX",
      },
      {
        img:
          "https://client.qtlauncher.com/images/?id=WOO-pescabingo_en_US&type=logo-square&version=1696304294656",
        alt: "Pesca Bingo",
        name: "Pesca Bingo",
        title: "Pesca Bingo",
        gameId: "WOO-pescabingo",
        tableId: "WOO",
      },
      {
        img:
          "https://luckmedia.link/wzd_extra_bingo/thumb_3_4_custom.webp?q=65&w=745&px=auto&auto=format",
        alt: "Extra Bingo",
        name: "Extra Bingo",
        title: "Extra Bingo",
        gameId: "WAZ-extrabingo",
        tableId: "",
      },
      {
        img:
          "https://client.qtlauncher.com/images/?id=EVP-candydreamsbingo_en_US&type=logo-square&version=1676298435123",
        alt: "Candy Dreams: Bingo",
        name: "Candy Dreams: Bingo",
        title: "Candy Dreams: Bingo",
        gameId: "EVP-candydreamsbingo",
        tableId: "EVP",
      },

      {
        img:
          "https://client.qtlauncher.com/images/?id=GLX-lottoboom_en_US&type=logo-square&version=1719221993390",
        alt: "Lotto Boom",
        name: "Lotto Boom",
        title: "Lotto Boom",
        gameId: "GLX-lottoboom",
        tableId: "GLX",
      },
      {
        img:
          "https://luckmedia.link/kir_keno/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "Keno",
        name: "Keno",
        title: "Keno",
        gameId: "KIR-keno",
        tableId: "KIR",
      },
      {
        img:
          "https://luckmedia.link/kir_lucky_loot/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "Lucky Loot",
        name: "Lucky Loot",
        title: "Lucky Loot",
        gameId: "KIR-luckyloot",
        tableId: "KIR",
      },
      {
        img:
          "https://luckmedia.link/kir_spin__win/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "Spin & Win",
        name: "Spin & Win",
        title: "Spin & Win",
        gameId: "KIR-spinandwin",
        tableId: "KIR",
      },
    ],
  },
  {
    name: "Scratch Card",
    data: [
      {
        img:
          "https://client.qtlauncher.com/images/?id=1x2-bloodbankscratch_en_US&type=logo-square&version=1676297129624",
        alt: "Blood Bank Scratch",
        name: "Blood Bank Scratch",
        title: "Blood Bank Scratch",
        gameId: "1x2-bloodbankscratch",
        tableId: "1x2",
      },
      {
        img:
          "https://client.qtlauncher.com/images/?id=HAK-scratchgold_en_US&type=logo-square&version=1663672812538",
        alt: "SCRATCH! Gold",
        name: "SCRATCH! Gold",
        title: "SCRATCH! Gold",
        gameId: "HAK-scratchgold",
        tableId: "HAK",
      },
      {
        img:
          "https://luckmedia.link/hcw_scratch_silver/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "SCRATCH! Silver",
        name: "SCRATCH! Silver",
        title: "SCRATCH! Silver",
        gameId: "HAK-scratchsilver",
        tableId: "HAK",
      },
      {
        img:
          "https://luckmedia.link/hcw_scratch_bronze/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "SCRATCH! Bronze",
        name: "SCRATCH! Bronze",
        title: "SCRATCH! Bronze",
        gameId: "HAK-scratchbronze",
        tableId: "HAK",
      },
      {
        img:
          "https://luckmedia.link/hcw_express_200_scratch/thumb_3_4_custom.webp?q=65&w=600&px=auto&auto=format",
        alt: "Express 200 Scratch",
        name: "Express 200 Scratch",
        title: "Express 200 Scratch",
        gameId: "HAK-express200scratch",
        tableId: "HAK",
      },
      {
        img:
          "https://client.qtlauncher.com/images/?id=HAK-cashscratch_en_US&type=logo-square&version=1663675909906",
        alt: "Cash Scratch",
        name: "Cash Scratch",
        title: "Cash Scratch",
        gameId: "HAK-cashscratch",
        tableId: "HAK",
      },
      {
        img:
          "https://client.qtlauncher.com/images/?id=HAK-chaoscrewscratch_en_US&type=logo-square&version=1663676053269",
        alt: "Chaos Crew Scratch",
        name: "Chaos Crew Scratch",
        title: "Chaos Crew Scratch",
        gameId: "HAK-chaoscrewscratch",
        tableId: "HAK",
      },
    ],
  },
];
